import { render, staticRenderFns } from "./waterOnDemand.vue?vue&type=template&id=f4384070"
import script from "./waterOnDemand.vue?vue&type=script&lang=js"
export * from "./waterOnDemand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports